import { cn } from '@/lib/utils';
import React, { useEffect, useState } from 'react';
import { AlarmsFilters } from '../MainContent/Alarms/AlarmsFilters';
import { Switch } from '@/components/ui/switch';
import { dispatch, RootState } from '@/store/store';
import { addDays, format } from 'date-fns';
import { useSelector } from 'react-redux';
import { DataType, setMetric } from '@/store/slices/assetsPreviewSlice/alarmsSlice';
import { REGULAR_DATE_FORMAT } from '@/const';

export function AlarmsActions() {
  const { alarmsDateRange } = useSelector((state: RootState) => state.assetsStudio);
  const fromDateISO = format(addDays(new Date(alarmsDateRange.from), 0), REGULAR_DATE_FORMAT);
  const toDateISO = format(addDays(new Date(alarmsDateRange.to), 0), REGULAR_DATE_FORMAT);
  const [dataType, setDataType] = useState<DataType>('count');

  useEffect(() => {
    dispatch(setMetric(dataType));
  }, [dataType]);

  return (
    <div className="w-full justify-between items-center flex">
      <div className="flex items-center gap-2">
        <AlarmsFilters />
        <div
          className={cn('w-fit whitespace-nowrap px-4 py-2 rounded-lg font-semibold text-sm bg-primary-50')}
          data-testid="viewing_indicator"
        >
          {`Viewing Alarms Data for: ${fromDateISO} - ${toDateISO} `}
        </div>
      </div>
      <div className="flex gap-2 items-center font-semibold ">
        <span className={cn(`${dataType === 'count' && 'text-primary-600'}`)}>Count</span>
        <Switch
          className={`${dataType === 'duration' ? '!bg-teal-600' : '!bg-primary-600'}`}
          checked={dataType === 'duration'}
          onClick={() => setDataType((prev: 'count' | 'duration') => (prev === 'count' ? 'duration' : 'count'))}
        />
        <span className={cn(`${dataType === 'duration' && 'text-teal-600'}`)}>Duration</span>
      </div>
    </div>
  );
}
